import React from "react";


const RenderResponsivequestions = (props) => {
 
  const participantFullName =
    props.invitationDetails &&
    props.invitationDetails.user_assessment__participant__full_name;
  const renderTextBasedOnGender = () => {
    if (
      props.assessmentType == "invitations" &&
      props.participant_gender == 1
    ) {
      return (
        <p style={{ paddingTop: "0px" }}>
          {`${props.questionList &&
            props.questionList.user_questions.question_statement_male
            }`.replace("#Name", `${participantFullName}`)}
        </p>
      );
    } else if (
      props.assessmentType == "invitations" &&
      props.participant_gender == 2
    ) {
      return (
        <p style={{ paddingTop: "0px" }}>
          {`${props.questionList &&
            props.questionList.user_questions.question_statement_female
            }`.replace("#Name", `${participantFullName}`)}
        </p>
      );
    } else if (
      props.assessmentType == "invitations" &&
      props.participant_gender == 3
    ) {
      return (
        <p style={{ paddingTop: "0px" }}>
          {`${props.questionList &&
            props.questionList.user_questions.question_statement_others
            }`.replace("#Name", `${participantFullName}`)}
        </p>
      );
    } else {
      return (
        <p style={{ paddingTop: "0px" }}>
          {props.questionList &&
            props.questionList.user_questions.question_statement_self}
        </p>
      );
    }
  };
  
  
  return (
    <div className="question-wrapper">

      <div className="question">
        <div className="q-number">
          <p style={{ color: "#30c534", paddingTop: '0px' }} >
            Q<span>{props.defaultQuestionNumber}.</span>
          </p>
        </div>
        <div className="questionText">{props.questionList === null ? "" : renderTextBasedOnGender()}</div>
      </div>
    </div>
  );
};
export default RenderResponsivequestions;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/responsive/responsive-question-wrapper.jsx